import type { Snapshot } from '@ember-data/legacy-compat/-private';
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import ApplicationSerializer from 'lumen/serializers/application';

// eslint-disable-next-line @typescript-eslint/no-unsafe-call
export default class CustomTagDefinitionSerializer extends ApplicationSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    readOnly: { serialize: false },
    options: { embedded: 'always' },
  };

  modelNameFromPayloadKey(key: string): string {
    if (key === 'options') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('custom-tag-list-option');
    }

    if (key === 'custom_tag_definitions') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
      return super.modelNameFromPayloadKey('custom-tag-definition');
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
    return super.modelNameFromPayloadKey(key);
  }

  payloadKeyFromModelName(): string {
    return 'custom_tag_definition';
  }

  serializeHasMany(
    snapshot: Snapshot,
    json: Record<string, unknown>,
    relationship: { key: string },
  ): void {
    if (relationship.key !== 'options') {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
      super.serializeHasMany(snapshot, json, relationship);
    }

    const optionSnapshots =
      (snapshot.hasMany('options') as
        | { attr: (key: string) => unknown }[]
        | undefined) ?? [];
    const labels = optionSnapshots
      .map((snap) => snap.attr('label') as string)
      .filter(Boolean);
    if (labels.length > 0) {
      json['options'] = labels;
    }
  }
}
